import * as React from 'react';

import { api } from '../../environment';
import Table from '../../components/table/Table';
import CheckBox from '../../components/formElements/CheckBox';
import { RemoveRedEye } from '@mui/icons-material';
import { Link } from 'react-router-dom';
import {utils, write}from 'xlsx';
import { saveAs } from 'file-saver';
import { FormDataBuilder, makeFormControls } from '../../components/formElements/util';
import Form from '../../components/formElements/Form';

export default function AbstractsView(){
    const [dataRows, setDataRows] = React.useState([]);
    

    const orderData = (data)=>{
        console.log("ORDER", data)
        return data.map((row, index) =>{
            row['order'] = index+1;
            return  row;
        })
    }

    const defineActions = (data)=>{
        return data.map((row, index)=>{
             row['action'] = <Link to={"/crs/pregled-sazetaka/"+row['id']}><RemoveRedEye/></Link>
             return row;
        })
    };


    const getData = (body) => {
        let call = fetch(api+"/get_abstracts",{
            method: "POST",
            headers: {
                "Content-Type": "application/json",
              },
              
              body:JSON.stringify({token:localStorage.getItem('site'), criteria:filter, ...body})
            })
            try{
        return call.then(response=>response.json())
            } catch (err){
                console.log(err)
                return [];
            }
    }

    const header = [{name:"order", label:"#", width:"5%"},{name:"activity_title", label:"Naslov", width:"25%", overflowX:'scroll'}, {name:"type", label:"Oblik sudjelovanja", width:"25%"}, {name:'theme', label:'Tematsko područje', width:"20%", overflowX:"scroll"}, {name:"status", label:"Status prijave", width:"20%"}, {name:"action", label:"akcija", width:"5%"}, ]

    const valueMapper = (name, value) => {
        let mapping = {
            "type" : {
                1: "Usmeno izlaganje - Psihologija u fokusu",
		2: "Usmeno izlaganje - Psihologija u akciji",
                3: "Simpozij",
                4: "Okrugli stol",
		5: "Panel rasprava",
                6: "Radionica",
		7: "Poster izlaganje",
                8: "Stručni domjenak",
                9: "Sastanak",
		10: "Predstavljanje",
                11: "Ostalo"
            },
            "theme":{
		"1": "Mentalno zdravlje u različitim životnim razdobljima i kontekstima",
		"2": "Klinička i zdravstvena psihologija: procjena, dijagnostika i tretman",
		"3": "Psihologija u obrazovanju i razvoju karijere",
		"4": "Rad, organizacije i specifični profesionalni sustavi",
		"5": "Zajednica, društveni kontekst i sustavi skrbi",
		"6": "Digitalno okruženje, mediji i suvremene tehnologije",
		"7": "Raznolikost, identitet i ljudska prava",
		"8": "Profesionalni identitet, etika, i razvoj struke"
            },
            "status":{
                0: "Čeka pregled",
                1: "Poslano na recenziju",
                2: "Prihvaćeno",
                3: "Prihvaćeno uz izmjene",
                4: "Odbijeno"
            },
            "independent":{
                0:"Samostalna aktivnost",
                1:"Aktivnost u okviru simpozija"
            }

        }
        if(mapping[name]==undefined) return value;
        console.log("VALUE",mapping[name][value])
        return mapping[name][value]
    }

    const mapValues = (data) =>{
        return data.map((row, index)=>{
            for(let name in row){
                row[name] = valueMapper(name,row[name])
            }
            return row
        })
    }

    // const mapValues = (data) =>{
    //     for(let row of data){
    //         row['type'] = mapType(row['type']);
    //         row['theme'] = mapTheme(row['theme']);
    //         row['status'] = mapStatus(row['status']);
    //     }
    //     return data
    // }

    const filterFormData = (new FormDataBuilder())
    .addTextField('activity_title', 'Pretraži naslove', false, false, [], {flex:"1 1 20%"}, null, 'input-field-no-border input-bottom-border')
    .addSelectField('type', 'Tip izlaganja', false, [
        {value:"0", text:'Sve'},
	{value:"1", text:"Usmeno izlaganje - Psihologija u fokusu"},
	{value:"2", text:"Usmeno izlaganje - Psihologija u akciji"},
	{value:"3", text:"Simpozij"},
	{value:"4", text:"Okrugli stol"},
	{value:"5", text:"Panel rasprava"},
	{value:"6", text:"Radionica"},
	{value:"7", text:"Poster izlaganje"},
	{value:"8", text:"Stručni domjenak"},
	{value:"9", text:"Sastanak stručne sekcije/radne skupine"},
	{value:"10", text:"Predstavljanje knjiga, psihologijskih mjernih instrumenata te drugih publikacija i uradaka"},
	{value:"11", text:"Ostale aktivnosti"}        
    ], false,[], {flex:'1 1 20%'}, null, 'input-field-no-border input-bottom-border')
    .addSelectField('theme', 'Tematsko područje', false, [
          {value:"1", text:"Mentalno zdravlje u različitim životnim razdobljima i kontekstima"},
  {value:"2", text:"Klinička i zdravstvena psihologija: procjena, dijagnostika i tretman"},
  {value:"3", text:"Psihologija u obrazovanju i razvoju karijere"},
  {value:"4", text:"Rad, organizacije i specifični profesionalni sustavi"},
  {value:"5", text:"Zajednica, društveni kontekst i sustavi skrbi"},
  {value:"6", text:"Digitalno okruženje, mediji i suvremene tehnologije"},
  {value:"7", text:"Raznolikost, identitet i ljudska prava"},
  {value:"8", text:"Profesionalni identitet, etika i razvoj struke"}
    ], false,[], {flex:'1 1 20%'}, null, 'input-field-no-border input-bottom-border')
    .addSelectField('status', 'Status', false, [
        {value:"-1", text:'Sve'},
        {value:'0', text:'Čeka pregled'},
        {value:'1', text:'Na recenziji'},
        {value:'2', text:'Prihvaćena'},
        {value:'3', text:'Prihvaćena uz izmjene'},
        {value:'4', text:'Odbijena'}
    ], false,[], {flex:'1 1 20%'}, null, 'input-field-no-border input-bottom-border').get();
    
    const [filter, setFilter] = React.useState(makeFormControls(filterFormData));

    React.useEffect(()=>{
        getData().then(
            data=>setDataRows(defineActions(orderData(mapValues(data))))
        )
    }, [filter])

    

    const exportToExcel = (data, fileName) => {
        const worksheet = utils.json_to_sheet(data);
        const workbook = utils.book_new();
        utils.book_append_sheet(workbook, worksheet, 'Sheet1');
        const excelBuffer = write(workbook, { bookType: 'xlsx', type: 'array' });
        const blob = new Blob([excelBuffer], {type: 'application/octet-stream'});
        saveAs(blob, `${fileName}.xlsx`);
      };

      const mutateDataForExport = (data) =>{
        const mapping = {

        }

        

        return data.map((row, index)=>{
            let mapping = {
                "type": "Vrsta izlaganja",
                "activity_title": "Naslov",
                "independent":"U okviru simpozija",
                "parent_activity_title": "Simpozij",
                "presenter": "Voditelj izlaganja",
                "presenter_email": "E-Mail adresa voditelja izlaganja",
                "contact": "Osoba za kontakt",
                "contact_email": "E-Mail adresa osobe za kontakt",
                "active_participant_string": "Autori",
                "theme": "Tematsko područje",
                "note": "Napomena",
                "status":"Status prijave"
            }
            let mutatedRow = {}
            for(let name in mapping){
                mutatedRow[mapping[name]] = row[name]
            }
        mutatedRow["Status prijave"] = row["status"]
            console.log(row);
            return mutatedRow
        })


    }


    return (
        <>
        <h1 style={{marginBottom:"2rem"}}>Pregled prijava sažetaka</h1>
        <div className="input-field" style={{marginTop:"0.5rem"}}>
            <div className="flex-row" style={{gap:"1%"}}>
        <Form formData={filterFormData} formControls={filter} setFormControls={setFilter}/>
        </div>
        <Table header={header} dataSource={dataRows!=undefined?dataRows:[]} layout="fixed"/>
        <button className="modal-button" style={{margin:"1rem"}}  onClick={()=>{exportToExcel(mutateDataForExport(dataRows), 'aktivnosti')}}>Izvoz u Excel</button>
        </div>
        </>
    )
}
